<ng-container *ngIf="relatedArticles1.length === 0 && relatedArticles2.length === 0 && relatedArticles3.length === 0">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
<ng-container *ngIf="relatedArticles1.length > 0">
  <h3>Related articles</h3>
    <div>
      <span *ngIf="relatedArticles1.length > 0">
        <app-link *ngFor="let item of relatedArticles1; let i = index" [to]="item.path">{{item.title}}</app-link>
      </span>
      <span *ngIf="relatedArticles2.length > 0">
        <app-link *ngFor="let item of relatedArticles2; let i = index" [to]="item.path">{{item.title}}</app-link>
      </span>
      <span *ngIf="relatedArticles3.length > 0">
        <app-link *ngFor="let item of relatedArticles3; let i = index" [to]="item.path">{{item.title}}</app-link>
      </span>
    </div>
</ng-container>
